import { createContext } from 'react'

import { EMPTY_LIST } from '../constants/common'

export const EmailAccounts = createContext({
  accounts: EMPTY_LIST,
  loading: true,
  serviceAccount: null,
})
